<template>
  <div
    class="fixed top-0 left-0 z-10 w-full bg-[#02031F] navmenu"
    :class="{
      'filter-shadow': !$store.state.search.open
    }"
  >
    <TopBlock />

    <PromoBlock v-if="showPromo" />

    <DunningSnackbar />

    <transition
      enter-active-class="transition-transform duration-100 transform"
      leave-active-class="transition-transform duration-100 transform"
      enter-class="translate-x-full"
      enter-to-class="translate-x-0"
      leave-class="translate-x-0"
      leave-to-class="translate-x-full"
    >
      <MobileDrawer
        v-show="$store.state.openTopNavDrawer"
        :has-referral-code="hasReferralCode()"
      />
    </transition>

    <SearchModal
      v-if="$store.state.search.open"
      :value="$store.state.search.open"
      @input="$store.commit('search/SET_OPEN', $event)" />
  </div>
</template>

<script>
import DunningSnackbar from '@/components/Dunning/dunning-snackbar.vue';
import TopBlock from './top-block';
import MobileDrawer from './drawer';
import PromoBlock from './promo-block.vue';
import SearchModal from '@/components/SearchModal/index.vue';

export default {
  components: {
    TopBlock,
    MobileDrawer,
    PromoBlock,
    DunningSnackbar,
    SearchModal
  },

  inject: ['hasPromo', 'hasIncentive', 'hasHolidayPromo', 'hasReferralCode', 'hasExtraMonthsBenefit', 'hasReactivationPromo'],

  computed: {
    showPromo() {
      if (this.hasReactivationPromo()) {
        return true;
      }
      const { path } = this.$route;
      if (this.hasReferralCode() || this.hasExtraMonthsBenefit()) {
        return path === '/pricing/';
      }

      if (this.hasPromo && this.hasHolidayPromo) {
        return path === '/';
      }
      return (
        this.hasPromo && (path.startsWith('/pricing') || path.startsWith('/account/subscription'))
      );
    },

    isYearly() {
      return this.$store.state.user.plan?.includes('yearly');
    },
  },
};
</script>

<style scoped></style>

<style>
.navmenu {
  z-index: 1000;
}
.filter-shadow {
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.15));
}
.bg-\[\#02031F\] {
  background-color: #02031F;
}
@screen sm {
  body.overflow-hidden .navmenu {
    z-index: auto;
  }
}
</style>
